import api from "../utils/api";

class UserOperatorApi {
  getAllUser = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/v1/operators/get-user", {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateOperator = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/v1/operators/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  changePassword = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/v1/operators/change-password`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getOperator = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/v1/operators/get-operator");
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getPayment = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/v1/operators/get-payment", {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post("/v1/operators/create/agent", data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/v1/operators/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/v1/operators/status/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateStatusUserAgent = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(
          `/v1/operators/status/user-agent/${id}`,
          data
        );
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/v1/operators/payment/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/user-permissions/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}

const userOperatorApi = new UserOperatorApi();
export default userOperatorApi;
